import PolicyLink from "../../components/PolicyLink";

export default function GFAHome({darkMode}) {
    return (
        <div className={`flex flex-col items-center ${darkMode ? 'dark' : ''}`}>
            <h2 className='font-bold text-center'>Canadian GFA Viewer</h2>
            <h3>Screenshots</h3>
            <div className="flex flex-row flex-wrap">
                <img className="m-2 w-36" alt="app screenshot" src="/gfa-viewer-screens/1.png" />
                <img className="m-2 w-36" alt="app screenshot" src="/gfa-viewer-screens/2.png" />
                <img className="m-2 w-36" alt="app screenshot" src="/gfa-viewer-screens/3.png" />
                <img className="m-2 w-36" alt="app screenshot" src="/gfa-viewer-screens/4.png" />
                <img className="m-2 w-36" alt="app screenshot" src="/gfa-viewer-screens/5.png" />
            </div>
            <h3>Contact Form</h3>
            <div className="flex h-[750px] w-full">
                <iframe title="support form" src="https://docs.google.com/forms/d/e/1FAIpQLSftDALiHxDxEiweqK6-CX9M9ecFX7Bryr3xKXFYNOLuJpRVmA/viewform?embedded=true" width="100%" height="700">Loading…</iframe>
            </div>
            <PolicyLink url={"https://www.termsfeed.com/live/5fb8f3c5-6dd1-48e6-8683-df3d5770b7c8"} />
        </div>
    )
}